"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@csod/assets/assets/normalize.css");
require("player-theming/theme.css");
require("@csod/assets/assets/csod-icons.css");
require("@csod/assets/assets/csod-style-utilities.css");
var utils_1 = require("player-core/utils");
exports.default = {
    createUUID: utils_1.createUUID
};
//# sourceMappingURL=__exports.js.map


//////////////////
// WEBPACK FOOTER
// ../player-search-module/node_modules/@csod/checkbox/build/__exports.js
// module id = 589
// module chunks = 0